/* eslint-disable */
import store from "../store/store";
import AddEditUser from "../views/users/AddEditUser";
import ListUsers from "../views/users/ListUsers";
import UserProfile from "../views/users/UserProfile";
import Notifications from "../views/notifications/Notifications";
import Index from "../views/Index.vue";
import Structures from "../views/structures/Structures";
import CheckPermissions from "./CheckPermissions";
import routePermissions from "../data/routePermissions/routePermissions";
import PermissionDenied from "../views/PermissionDenied";
import DaysOffRequest from "../views/absenceRequest/DaysOffRequest";
import MyHistory from "../views/absenceRequest/MyHistory";
import Answer from "../views/absenceRequest/Answer";
import SimpleAbsenceRequest from "../views/absenceRequest/SimpleAbsenceRequest";
import RecoveryTimeRequest from "../views/absenceRequest/RecoveryTimeRequest";
import RecoveryRequest from "../views/absenceRequest/RecoveryRequest";
import AttendanceApp from "../views/attendance/AttendanceApp";
import ReportForm from "../views/DailyReport/ReportForm";
import DailyReportCalendar from "../views/DailyReport/DailyReportCalendar";
import ReportCard from "../views/DailyReport/ReportCard";
import ManagerViewCalendar from "../views/DailyReport/ManagerViewCalendar";
import TaskList from "../views/Tasks/TaskList";
import PersonalTasks from "../views/Tasks/PersonalTasks";
import leaveByAccountant from "../views/leave/leaveByAccountant";
import contact from "../views/contact/contact";
import rgpd from "../views/rgpd/rgpd";
import RequestManagement from "../views/absenceRequest/RequestManagement";
import MinibusRequest from "../views/minibus/MinibusRequest";
import MinibusRequestManagement from "../views/minibus/MinibusRequestManagement"
import MinibusDemand from "../views/minibus/MinibusDemand";
import MinibusManagement from "../views/minibus/MinibusManagement";
import MinibusPlaning from "../views/minibus/MinibusPlaning";
import MinibusManuelReservation from "../views/minibus/MinibusManuelReservation";
import ContractRequest from "../views/contract/ContractRequest";
import ContractAnswer from "../views/contract/ContractAnswer";
import ContractRequestManagement from "../views/contract/ContractRequestManagement";
import EmployeeManagement from "../views/employee/EmployeeManagement";
import Employee from "../views/employee/Employee";
import RegieRequest from "../views/regie/RegieRequest";
import RegieRequestManagement from "../views/regie/RegieRequestManagement";
import RegieAnswer from "../views/regie/RegieAnswer";
import RetourRegieRequest from "../views/retourRegie/RetourRegieRequest";
import RetourRegieRequestManagement from "../views/retourRegie/RetourRegieRequestManagement";
import RetourRegieAnswer from "../views/retourRegie/RetourRegieAnswer";



const layout = [
  {
    path: "/",
    component: Index,
    meta: {
      title: "Dashboard"
    }
  },
  {
    path: "/liste-utilisateurs",
    name: "list-users",
    component: ListUsers,
    meta: {
      title: "Liste des utilisateurs"
    },
    beforeEnter: CheckPermissions(
      store.state.user.informations,
      routePermissions["list-users"]
    )
  },
  {
    path: "/permission-denied",
    name: "permission-denied",
    component: PermissionDenied,
    meta: {
      title: "Vous n'avez pas les droits nécessaires"
    }
  },
  {
    path: "/ajout-utilisateur",
    name: "add-user",
    component: AddEditUser,
    meta: {
      title: "Ajouter un utilisateur"
    },
    beforeEnter: CheckPermissions(
      store.state.user.informations,
      routePermissions["add-user"]
    )
  },
  {
    path: "/edit-utilisateur/:reference",
    name: "edit-user",
    component: AddEditUser,
    meta: {
      title: "Editer un utilisateur"
    },
    beforeEnter: CheckPermissions(
      store.state.user.informations,
      routePermissions["edit-user"]
    )
  },
  {
    path: "/mon-compte",
    name: "user-profile",
    component: UserProfile,
    meta: {
      title: "Mon compte"
    }
  },
  {
    path: "/profile/:reference",
    name: "account-profile",
    component: UserProfile,
    meta: {
      title: "Profile"
    },
    beforeEnter: CheckPermissions(
      store.state.user.informations,
      routePermissions["account-profile"]
    )
  },
  {
    path: "/mes-notifications",
    name: "my-notifications",
    component: Notifications,
    meta: {
      title: "Notifications"
    }
  },
  {
    path: "/rgpd",
    name: "rgpd",
    component: rgpd,
    meta: {
      title: "RGPD"
    }
  },
  {
    path: "/demandes/historique",
    name: "days-off-history",
    component: MyHistory,
    meta: {
      title: "Mon historique de demandes"
    }
  },
  {
    path: "/demandes/gestionnaire",
    name: "request-manager",
    component: RequestManagement,
    meta: {
      title: "Gestion de congés"
    },
    beforeEnter: CheckPermissions(
      store.state.user.informations,
      routePermissions["leave-request-manager"]
    )
  },
  {
    path: "/demandes/conges",
    name: "days-off-request",
    component: DaysOffRequest,
    meta: {
      title: "Demande de conges"
    }
  },
  {
    path: "/demandes/absence",
    name: "simple-absence-request",
    component: SimpleAbsenceRequest,
    meta: {
      title: "Demande d'absence temporaire"
    }
  },
  {
    path: "/demandes/declaration-heures",
    name: "recovery-time-request",
    component: RecoveryTimeRequest,
    meta: {
      title: "Declaration d'heures supp"
    }
  },
  {
    path: "/demandes/recuperation",
    name: "recovery-request",
    component: RecoveryRequest,
    meta: {
      title: "Demande de recuperation"
    }
  },
  {
    path: "/demandes/minibus",
    name: "minibus-request",
    component: MinibusRequest,
    meta: {
      title: "Demande de minibus"
    }
  },
  {
    path: "/demandes/minibus/management",
    name: "minibus-request-manager",
    component: MinibusRequestManagement,
    meta: {
      title: "Management de minibus"
    }
  },
  {
    path: "/demandes/minibus/management/demand/:reference",
    name: "minibus-demand",
    component: MinibusDemand,
    meta: {
      title: "Demand of minibus"
    }
  },
  {
    path: "management/minibus",
    name: "minibus-management",
    component: MinibusManagement,
    meta: {
      title: "Minibus Managment"
    }
  },
  {
    path: "/minibus/planing/:reference",
    name: "minibus-planning",
    component: MinibusPlaning,
    meta: {
      title: "Minibus Planing"
    }
  },
  {
    path: "/demandes/minibus/manuel",
    name: "minibus-manuel-reservation",
    component: MinibusManuelReservation,
    meta: {
      title: "Minibus Manuel Reservation"
    }
  },
  {
    path: "/contracts",
    name: "contract-request",
    component: ContractRequest,
    meta: {
      title: "Contract Request"
    }
  },
  {
    path: "/regies",
    name: "regie-request",
    component: RegieRequest,
    meta: {
      title: "Régie Request"
    }
  },
  {
    path: "/retourRegies",
    name: "retour-regie-request",
    component: RetourRegieRequest,
    meta: {
      title: "Retour Régie Request"
    }
  },
  {
    path: "/contracts/:reference",
    name: "contract-answer",
    component: ContractAnswer,
    meta: {
      title: "Contract Answer"
    }
  },
  {
    path: "/regies/:reference",
    name: "regie-answer",
    component: RegieAnswer,
    meta: {
      title: "Régie Answer"
    }
  },
  {
    path: "/retourRegies/:reference",
    name: "retour-regie-answer",
    component: RetourRegieAnswer,
    meta: {
      title: "Retour Régie Answer"
    }
  },
  {
    path: "/gestionnaire/contracts",
    name: "contract-request-management",
    component: ContractRequestManagement,
    meta: {
      title: "Contract Request Management"
    }
  },
  {
    path: "/gestionnaire/regies",
    name: "regie-request-management",
    component: RegieRequestManagement,
    meta: {
      title: "Régie Request Management"
    }
  },
  {
    path: "/gestionnaire/retourRegies",
    name: "retour-regie-request-management",
    component: RetourRegieRequestManagement,
    meta: {
      title: "Retour Régie Request Management"
    }
  },
  {
    path: "/employeeManagement",
    name: "employee-management",
    component: EmployeeManagement,
    meta: {
      title: "Employee Management"
    }
  },
  {
    path: "/employee/:reference",
    name: "employee",
    component: Employee,
    meta: {
      title: "Employee"
    }
  },
  {
    path: "/demandes/repondre/:reference",
    name: "days-off-answer",
    component: Answer,
    meta: {
      title: "Reponse a une demande"
    },
    beforeEnter: CheckPermissions(
      store.state.user.informations,
      routePermissions["days-off-answer"]
    )
  },
  {
    path: "/attendance",
    name: "attendance-app",
    component: AttendanceApp,
    beforeEnter: CheckPermissions(
      store.state.user.informations,
      routePermissions["menu.attendance.io"]
    ),
    meta: {
      title: "Attendance App"
    }
  },
  {
    path: "/reportForm/:create",
    name: "reportForm",
    component: ReportForm,
    props: true,
    meta: {
      title: "Report Form"
    }
  },
  {
    path: "/dailyReportCalendar",
    name: "dailyReportCalendar",
    component: DailyReportCalendar,
    meta: {
      title: "Daily Report"
    }
  },
  {
    path: "/reportCard",
    name: "daily-report-card-view",
    component: ReportCard,
    meta: {
      title: "Report Cards"
    }
  },
  {
    path: "/employeeReport",
    name: "manager-daily-report-card-view",
    component: ManagerViewCalendar,
    beforeEnter: CheckPermissions(
      store.state.user.informations,
      routePermissions["menu.taskManagerView"]
    ),
    meta: {
      title: "Manager Daily Report Card View"
    }
  },
  {
    path: "/personalTasks",
    name: "personal-tasks",
    component: PersonalTasks,
    meta: {
      title: "Task List for Person"
    }
  },
  {
    path: "/personalTasks/:reference",
    name: "personal-tasks",
    component: PersonalTasks,
    meta: {
      title: "Task"
    }
  },
  {
    path: "/tasks",
    name: "tasks-list",
    component: TaskList,
    beforeEnter: CheckPermissions(
      store.state.user.informations,
      routePermissions["menu.taskManagerView"]
    ),
    meta: {
      title: "Task List for Employees"
    }
  },
  {
    path: "/tasks/:reference",
    name: "tasks-list",
    component: TaskList,
    meta: {
      title: "Task"
    }
  },
  {
    path: "/leaveByAccountant",
    name: "leave-by-accountant",
    component: leaveByAccountant,
    beforeEnter: CheckPermissions(
      store.state.user.informations,
      routePermissions["medicalLeave"]
    ),
    meta: {
      title: "leave By Accountant"
    }
  },
  {
    path: "/contact",
    name: "contact",
    component: contact,
    meta: {
      title: "contact us"
    }
  },
  {
    path: "/structures",
    name: "structures",
    component: Structures,
    meta: {
      title: "Structures"
    },
    beforeEnter: CheckPermissions(
      store.state.user.informations,
      routePermissions["structures"]
    )
  }
];
export default layout;
